import { Inject, Injectable, Optional } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NOTIFICATION_DURATION } from '@rentigo/ngx-common';
import { DashboardNotificationComponent } from './dashboard-notification.component';

@Injectable({
  providedIn: 'root'
})
export class DashboardNotificationService {

  private readonly DEFAULT_NOTIFICATION_DURATION: number = 6000;
  private readonly DEFAULT_ERROR_NOTIFICATION_DURATION: number = 30000;
  private readonly DEFAULT_VERTICAL_POSITION: MatSnackBarVerticalPosition = 'top';
  private readonly DEFAULT_HORIZONTAL_POSITION: MatSnackBarHorizontalPosition = 'right';

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Optional()
    @Inject(NOTIFICATION_DURATION)
    notificationDuration: number) {
    this.DEFAULT_NOTIFICATION_DURATION = notificationDuration || this.DEFAULT_NOTIFICATION_DURATION;
  }

  notify(message: string, duration?: number) {
    this.snackBar.openFromComponent(DashboardNotificationComponent, {
      data: message,
      duration: duration || this.DEFAULT_NOTIFICATION_DURATION
    });
  }

  success(message: string, duration?: number) {
    this.snackBar.openFromComponent(DashboardNotificationComponent, {
      data: message,
      panelClass: ['notification', 'notification-success'],
      horizontalPosition: this.DEFAULT_HORIZONTAL_POSITION,
      verticalPosition: this.DEFAULT_VERTICAL_POSITION,
      politeness: 'polite',
      duration: duration || this.DEFAULT_NOTIFICATION_DURATION
    });
  }

  warning(message: string, duration?: number) {
    this.snackBar.openFromComponent(DashboardNotificationComponent, {
      data: message,
      panelClass: ['notification', 'notification-warning'],
      horizontalPosition: this.DEFAULT_HORIZONTAL_POSITION,
      verticalPosition: this.DEFAULT_VERTICAL_POSITION,
      politeness: 'polite',
      duration: duration || this.DEFAULT_NOTIFICATION_DURATION
    });
  }

  error(error: any, duration?: number) {
    const message = this.getErrorMessage(error);
    this.snackBar.openFromComponent(DashboardNotificationComponent, {
      data: message,
      panelClass: ['notification', 'notification-error'],
      horizontalPosition: this.DEFAULT_HORIZONTAL_POSITION,
      verticalPosition: this.DEFAULT_VERTICAL_POSITION,
      politeness: 'polite',
      duration: duration || this.DEFAULT_ERROR_NOTIFICATION_DURATION
    });
  }

  private getErrorMessage(httpError: any) {
    if (!httpError) {
      return null;
    }
    if (this.isProperMessage(httpError)) {
      return httpError;
    }

    if (httpError.error) {
      if (this.isProperMessage(httpError.error)) {
        return httpError.error;
      }

      const message =
        httpError.error?.detail ||
        httpError.error?.Message ||
        httpError.error?.message ||
        httpError.error?.Error?.Message ||
        httpError.error?.error?.message;

      if (this.isProperMessage(message)) {
        return UserErrors[message] ?? message;
      }
    }

    if (this.isProperMessage(httpError.statusText)) {
      return httpError.statusText;
    }

    return 'Unknown error';
  }

  private isProperMessage(value: any): boolean {
    return value && typeof value === 'string';
  }
}

const UserErrors: { [key: string]: string } = {
  ['Resident with this email cannot be archived.']: 'Resident with this email already exists',
}
